import createApiServices from './createApiServices'
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})

export const getContactList = (userName, payload) => {
    return api.makeRequest({
        url: `/crm/searchContactList?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const importListContact = (contactListName, createBy, payload) => {
    return api.makeRequest({
        url: `/crm/uploadContactList?createBy=${createBy}&contactListName=${contactListName}`,
        method: 'POST',
        data: payload
    })
}
